"use strict";
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uuidable = exports.uuidableAttributeNames = void 0;
const uuid_1 = require("uuid");
const ParamsValidatorUtils_1 = require("../../utils/ParamsValidatorUtils");
exports.uuidableAttributeNames = ['_uuid'];
class Uuidable {
    constructor(_uuid) {
        this._uuid = Uuidable.getUuid(_uuid);
    }
    get uuid() {
        return this._uuid;
    }
    static getUuid(_uuid) {
        if (_uuid && !(0, uuid_1.validate)(_uuid)) {
            throw new Error('Uuidable: invalid uuid');
        }
        else if (_uuid) {
            return _uuid;
        }
        else {
            return (0, uuid_1.v4)();
        }
    }
    /**
     * validates provided _uuid in params
     * @param dirtyParams the params input
     * @param displayName the name of the object being validated
     * @returns Error[]
     */
    static validateParams(dirtyParams, displayName) {
        const errors = [];
        errors.push(...ParamsValidatorUtils_1.ParamsValidatorUtils.isUuid('_uuid', dirtyParams._uuid, displayName ? displayName + ' Uuidable' : 'Uuidable'));
        return errors;
    }
}
exports.Uuidable = Uuidable;
//# sourceMappingURL=Uuidable.js.map